import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Edit,Delete,Done,Block,Visibility,Gavel,DriveEta,Close} from '@material-ui/icons';

import { withLocalize,Translate } from "react-localize-redux";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Link,
  Slide
} from "@material-ui/core";


import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import {ReportingService, TransportService} from "./../../utils/web_config_2";

import UserInfo from "./login_info";

import axios from 'axios';

import Format from "date-fns/format";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
 },
appBar: {
  position: 'relative',
},
title: {
  marginLeft: theme.spacing(2),
  flex: 1,
}
}));


 function DriverReport() {
  const classes = useStyles1();

  
  // new offense dialog 

  const [open, setOpen] = useState(false);

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [fineMessage,setFineMessage]=useState("Loading...");


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

// driver table 


const columns = [
  {
    name: "username",
    label: "Driver",
    options: {
     display:false,
     filter: true,
     sort: true
    }
   },
  {
   name: "username",
   label: "Driver Name",
   options: {
    filter: true,
    sort: true,
    customBodyRender: (value, tableMeta, updateValue) => {
      return (<Typography color="primary"><Link href="#" onClick={()=>{
        get_buses(value)
      }}>
        {value}
      </Link>
      </Typography>
      );
     }
   }
  }
 ];

 
 const options = {textLabels: {
  body: {
    noMatch: fineMessage
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows: false,
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>
      <Chip 
      className={classes.chip} 
      icon={ <Visibility/>} 
      color="primary" 
      variant="outlined" 
      label="View offenses" 
      onClick={()=>{
 var id=displayData[selectedRows.data[0]['index']]['data'][0];
 get_offenses(id);
}} />
      </Box>
  ),
 };

// plate number table 


const columns2 = [
  {
    name: "numberPlate",
    label: "Number Plate",
    options: {
     display:false,
     filter: true,
     sort: true
    }
   },
  {
   name: "numberPlate",
   label: "Plate Number",
   options: {
    filter: true,
    sort: true,
    customBodyRender: (value, tableMeta, updateValue) => {
      return (<Typography color="primary"><Link href="#" onClick={()=>{
        get_driver_route_details(value);
      }}>
        {value}
      </Link>
      </Typography>
      );
     }
   }
  }
 ];


 const options2 = {textLabels: {
  body: {
    noMatch: "Loading..."
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows: false,
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>
      <Chip 
      className={classes.chip} 
      icon={ <Visibility/>} 
      color="primary" 
      variant="outlined" 
      label="View offenses" 
      onClick={()=>{
 var id=displayData[selectedRows.data[0]['index']]['data'][0];
 get_offenses(id);
}} />
      </Box>
  ),
 };


// start driver routes 


const columns3 = [
  {
    name: "date",
    label: "Date",
    options: {
     filter: true,
     sort: true
    }
   },
   {
    name: "departure_time",
    label: "Departure Time",
    options: {
     filter: true,
     sort: true
    }
   },
   {
    name: "route",
    label: "Route",
    options: {
     filter: true,
     sort: true
    }
   },
   {
    name: "total_tickets",
    label: "Total Tickets",
    options: {
     filter: true,
     sort: true
    }
   },
   {
    name: "total_amount",
    label: "Total Amount",
    options: {
     filter: true,
     sort: true
    }
   },
   {
    name: "total_luggage_tickets",
    label: "Total Luggage",
    options: {
     filter: true,
     sort: true
    }
   },
   {
    name: "total_luggage_amount",
    label: "Amount Luggage",
    options: {
     filter: true,
     sort: true
    }
   },
   {
    name: "luggage_value_tickets",
    label: "Luggage Value",
    options: {
     filter: true,
     sort: true
    }
   },
   {
    name: "luggage_value_amount",
    label: "Amount Laggage",
    options: {
     filter: true,
     sort: true
    }
   },
   {
    name: "total_luggage_amount",
    label: "Total",
    options: {
     filter: true,
     sort: true
    }
   }
  // {
  //  name: "numberPlate",
  //  label: "Plate Number",
  //  options: {
  //   filter: true,
  //   sort: true,
  //   customBodyRender: (value, tableMeta, updateValue) => {
  //     return (<Typography color="primary"><Link href="#" onClick={()=>{
  //       get_driver_route_details(value);
  //     }}>
  //       {value}
  //     </Link>
  //     </Typography>
  //     );
  //    }
  //  }
  // }
 ];


 const options3 = {textLabels: {
  body: {
    noMatch: "Loading..."
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows: false,
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>
      <Chip 
      className={classes.chip} 
      icon={ <Visibility/>} 
      color="primary" 
      variant="outlined" 
      label="View offenses" 
      onClick={()=>{
 var id=displayData[selectedRows.data[0]['index']]['data'][0];
 get_offenses(id);
}} 
/>
      </Box>
  ),
 };

// end driver routes



 const [today,setToday]=useState(Format(new Date(), ["yyyy-MM-dd",]));




 useEffect(()=>{

  var data = {};
  const data1 = localStorage.getItem("nx_op");
  if (data1 != null) {
    data = JSON.parse(data1);
  }

  setOperatorData(data);
  axios.defaults.baseURL = new ReportingService().BASE_URL;

  get_driver_report(data.token);

 },[]);


 // get fines
const [fineLoad,setFineLoad]=useState(false);
 const [fines,setFines]=useState([]);
 const get_driver_report=(token)=>{
  setFineMessage("Loading...");
   setFineLoad(true);
   const driversInstance = axios.create(new ReportingService().setHeaders(token));
   driversInstance.post('/driverReport/pullDrivers',{
    "company_id": new UserInfo().ORG_ID,
    "today": Format(new Date(), ["yyyy-MM-dd",])
  })
   .then(res=>{

    var data=[];
     var objs=res.data.data;
     objs.map((o)=>{
      if(o!=null){
        data.push(o)
      }
     });
     setFineLoad(false);
     setFines(data);


   }).catch(err=>{
     setFineLoad(false);
    enqueueSnackbar(err.message,
      { 
        variant: 'error'
    });
   });
   
 }


 // offense dialog 
 const [offenseDialog,setOffenseDialog]=useState(false);
 // get offense 
 const [offenses,setOffenses]=useState([]);
 const get_offenses=(id)=>{
   var of=fines.find((o)=>o.id==id);
   setOffenses(of['offences']);
   setOffenseDialog(true);
 }


 // driver report //

 const [levelTwoDialog,setLevelTwoDialog]=useState(false)

 const [plateNumberList,setPlateNumberList]=useState([]);
 const [busLoading,setBusLoading]=useState(false)
 const get_buses=(username)=>{
  axios.defaults.baseURL = new ReportingService().BASE_URL;
  setLevelTwoDialog(true);
  setBusLoading(true);
  const busesInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
  busesInstance.post('/driverReport/pullDriversLevelTwo',
    {
      "company_id": new UserInfo().ORG_ID,
      "today": today,
      "username": username
    }
    )
  .then(res=>{
    setBusLoading(false);
    var objs=res.data.data;
    setPlateNumberList(objs);

  }).catch(err=>{
    setBusLoading(false);
    enqueueSnackbar(err.message,
     { 
       variant: 'error'
   });
  });
 }

 // driver report level 3 

 const [levelThreeDialog,setLevelThreeDialog]=useState(false)
 const [levelThreeLoading,setLevelThreeLoading]=useState(false)
 const [driverRoutes,setDriverRoutes]=useState([]);

 const get_driver_route_details=(plate_number)=>{
  axios.defaults.baseURL = new ReportingService().BASE_URL;
  setLevelThreeLoading(true)
  setLevelThreeDialog(true)
  const driversReportInstance = axios.create(new ReportingService().setHeaders(operatorData.token));
  driversReportInstance.post('/driverReport/pullDriversRouteDetails',
  {
    "company_id":new UserInfo().ORG_ID,
    "number_plate":plate_number,
    "today":today
  }
  ) .then(res=>{
    setLevelThreeLoading(false)
    var objs=res.data.data;
    setDriverRoutes(objs);
  }).catch(err=>{
    setLevelThreeLoading(false)
    enqueueSnackbar(err.message,
     { 
       variant: 'error'
   });
  });

 }


  return (
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><DriveEta fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Driver Report</b></Typography>

 </Box>
 

</Box>


<Box mt={2}>
  {fineLoad&&<LinearProgress/>}
<MUIDataTable
  title={"Driver list"}
  data={fines}
  columns={columns}
  options={options}
/>
</Box> 


{/* driver dialog */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={offenseDialog}
        onClose={()=>{
          setOffenseDialog(false);
        }}
        aria-labelledby="fines"
        aria-describedby="fines"
      >
        <DialogTitle id="driver_report">{"Driver Report"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          <List>
            {offenses.map((o)=>{
              return  <ListItem>
              <ListItemAvatar>
                  <Gavel/>
              </ListItemAvatar>
              <ListItemText primary={o['offense']['name']} secondary={o['amount']} />
            </ListItem>;
            })}
     
      
    </List>
        
          </Box>
         </DialogContentText>
         </DialogContent>

         <DialogActions>
         
          <Button onClick={()=>{
             setOffenseDialog(false);
          }} color="secondary" className={classes.btn}>
            <Typography>Close</Typography>
          </Button>


        </DialogActions>
         </Dialog>


 {/* level two */}

         <Dialog fullScreen open={levelTwoDialog} style={{marginTop:"80px"}}  onClose={()=>{
   
  }} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={()=>{
                setLevelTwoDialog(false);
  }} aria-label="close">
                <Close />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Tickets
              </Typography>
  
              <Button autoFocus color="inherit" onClick={()=>{
                setLevelTwoDialog(false);
  }}>
                Close
              </Button>
            </Toolbar>
          </AppBar>
  
  <Box mt={2}>

  {busLoading&&<LinearProgress />}
  <MUIDataTable
    title={"Plate Number List"}
    data={plateNumberList}
    columns={columns2}
    options={options2}
  /> 

  </Box>  
  
  </Dialog>
  

{/* level three report  */}

<Dialog fullScreen open={levelThreeDialog} style={{marginTop:"80px"}}  onClose={()=>{
   
  }} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={()=>{
                setLevelTwoDialog(false);
  }} aria-label="close">
                <Close />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                Ticket Passengers
              </Typography>
  
              <Button autoFocus color="inherit" onClick={()=>{
                setLevelThreeDialog(false);
  }}>
                Close
              </Button>
            </Toolbar>
          </AppBar>
  
  <Box mt={2}>

  {levelThreeLoading&&<LinearProgress />}
  <MUIDataTable
    title={"Passenger Tickets"}
    data={driverRoutes}
    columns={columns3}
    options={options3}
  /> 

  </Box>  
  
  </Dialog>


 </div>
  );
}

export default withLocalize(DriverReport)